/* eslint-disable import/prefer-default-export */
import axios from 'axios';

import { getServerUrl } from '../constants';
import { getAuthTokenFromStorage, getUserIdFromStorage } from '../utils';

const SUBROUTE = 'candidate';

/**
 * @description gets candidate by id
 * @param {String} id candidate id
 * @returns {Promise<Object>} API response
 */
export const fetchCandidateById = async (id) => {
  if (!global.API_URL) {
    global.API_URL = getServerUrl();
  }

  const url = `${global.API_URL}/${SUBROUTE}/${id}`;

  try {
    const { data: { data } } = await axios.get(url);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

/**
 * @description creates a race object in the database
 * @param {Object} fields object with data to send
 * @param {String} fields.name name of candidate
 * @param {String} fields.party candidate's party
 * @param {String} fields.biographical_info candidate's biographical info
 * @param {Object} fields.social_media candidate's social media pages (key is name of platform, value is link)
 * @param {Object} fields.contact_info candidate's contact info (email, phone_number, and website fields)
 * @returns {Object} api response
 */
export const createCandidate = async (fields) => {
  const url = `${global.API_URL}/${SUBROUTE}`;
  const token = getAuthTokenFromStorage();

  try {
    const { data: { data } } = await axios.post(url, {
      ...fields,
      created_by: getUserIdFromStorage(),
    }, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

/**
 * @description approves a candidate object
 * @param {String} id id of candidate object
 * @returns {Promise<Object>} API response
 */
export const adminApproveCandidate = async (id) => {
  if (!global.API_URL) {
    global.API_URL = getServerUrl();
  }

  const url = `${global.API_URL}/${SUBROUTE}/admin/approve/${id}`;
  const token = getAuthTokenFromStorage();

  try {
    const { data: { data } } = await axios.get(url, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

/**
 * @description unapproves a candidate object
 * @param {String} id id of candidate object
 * @returns {Promise<Object>} API response
 */
export const adminUnapproveCandidate = async (id) => {
  if (!global.API_URL) {
    global.API_URL = getServerUrl();
  }

  const url = `${global.API_URL}/${SUBROUTE}/admin/unapprove/${id}`;
  const token = getAuthTokenFromStorage();

  try {
    const { data: { data } } = await axios.get(url, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

/**
 * @description gets all candidates that are approved
 * @returns {Promise<Object>} API response
 */
export const fetchAllApprovedCandidates = async () => {
  if (!global.API_URL) {
    global.API_URL = getServerUrl();
  }

  const url = `${global.API_URL}/${SUBROUTE}/approved`;

  try {
    const { data: { data } } = await axios.get(url);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

/**
 * @description gets all candidates that are unapproved
 * @returns {Promise<Object>} API response
 */
export const fetchAllUnapprovedCandidates = async () => {
  if (!global.API_URL) {
    global.API_URL = getServerUrl();
  }

  const url = `${global.API_URL}/${SUBROUTE}/unapproved`;

  try {
    const { data: { data } } = await axios.get(url);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
